import { CSSProperties } from 'react';

export const profilePhotosContainer: CSSProperties = {
  display: 'flex',
  gap: '8px',
  paddingLeft: '12px',
  paddingRight: '12px'
};

export const profilePhotosMainCard = (hasPhoto: boolean): CSSProperties => ({
  flex: 1,
  aspectRatio: '3 / 4',
  borderRadius: '20px',
  backgroundImage: hasPhoto
    ? 'none'
    : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3E%3Crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23000' stroke-width='0.5' stroke-dasharray='4%2C4'/%3E%3C/svg%3E")`,
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: hasPhoto ? 'default' : 'pointer',
  position: 'relative'
});

export const profilePhotosSelectedImage: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '20px',
  overflow: 'hidden'
};

export const profilePhotosDeleteSelectedImageButton: CSSProperties = {
  position: 'absolute',
  top: '-9px',
  right: '-4px',
  backgroundColor: '#000',
  border: '1px solid #ffffff',
  borderRadius: '20px',
  width: '24px',
  height: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  margin: 0,
  cursor: 'pointer',
  zIndex: 20
};

export const profilePhotosPendingImageButton: CSSProperties = {
  position: 'absolute',
  top: '5px',
  right: '5px',
  zIndex: 20,
  opacity: 0.7,
  backgroundColor: '#000',
  color: '#fff',
  border: 'none',
  borderRadius: '15px',
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  overflow: 'hidden',
  padding: '4px 5px'
};

export const profilePhotosSecondaryContainer: CSSProperties = {
  display: 'contents'
};

export const mainProfilePhotoImageInputContainer: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative'
};

export const mainProfilePhotoImageInputText: CSSProperties = {
  fontSize: '10px',
  color: '#000',
  fontWeight: 510,
  marginTop: '5px',
  textAlign: 'center'
};

export const profilePhotosImageInput: CSSProperties = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  opacity: 0,
  cursor: 'pointer'
};

export const profilePhotosSelectImagePlus: CSSProperties = {
  fontSize: '48px',
  color: '#d9d9d9',
  borderRadius: '20px'
};

export const profilePhotosSecondaryCard = (
  hasPhoto: boolean
): CSSProperties => ({
  flex: 1,
  aspectRatio: '3 / 4',
  borderRadius: '20px',
  backgroundImage: hasPhoto
    ? 'none'
    : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3E%3Crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23000' stroke-width='0.5' stroke-dasharray='4%2C4'/%3E%3C/svg%3E")`,
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: hasPhoto ? 'default' : 'pointer',
  position: 'relative'
});

export const profilePhotoOrderLabel: CSSProperties = {
  position: 'absolute' as const,
  bottom: '-1px',
  left: '0px',
  backgroundColor: '#000',
  color: '#fff',
  border: 'none',
  fontSize: '9px',
  fontWeight: 510,
  padding: '3px 8px',
  borderRadius: '20px',
  zIndex: 20,
  backdropFilter: 'blur(14px)'
};
